import { render, staticRenderFns } from "./_base-category-picker.vue?vue&type=template&id=0e32953d&scoped=true&"
import script from "./_base-category-picker.vue?vue&type=script&lang=js&"
export * from "./_base-category-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-category-picker.vue?vue&type=style&index=0&id=0e32953d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e32953d",
  null
  
)

export default component.exports